import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/smartAdminUI/Button';

const SaveAsIncomplete = ({
  onSubmit = () => null,
  buttonText = 'Save Incomplete',
  isDisabled = false,
}) => (
  <>
    <Button
      name="btnSaveIncompleteListing"
      variant="warning btn-sm d-none d-lg-block"
      onClick={onSubmit}
      disabled={isDisabled}
    >
      <i className="far fa-save mr-2" aria-hidden="true" />
      {buttonText}
    </Button>
    <Button
      name="btnSaveIncompleteListing"
      variant="warning btn-sm d-block d-lg-none"
      onClick={onSubmit}
      tooltipText={buttonText}
    >
      <i className="far fa-save" aria-hidden="true" />
    </Button>
  </>
);

SaveAsIncomplete.propTypes = {
  isDisabled: PropTypes.bool,
  onSubmit: PropTypes.func,
  buttonText: PropTypes.string,
};

export default SaveAsIncomplete;
